import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  staffs: {},
  selectedStaffId: "",
  staff: {},
  staffSelectList: [],
  staffSelectListForRequests: [],
  selectedStaffIdForUpdateOrderStatus: "",
  requestStaffList: [],
  selectedStaffRenewalDetails:{}
};

const staff = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_STAFFS_LIST: {
      const modifiedData = payload?.staffs?.data?.map((element, index) => ({...element, key:index}))
      
      draft.staffs = {...payload?.staffs, data:modifiedData};
      break;
    }
    case Actions.GET_STAFFS_SELECT_LIST: {
      const tempStaffSelectList = payload?.staffs?.data?.filter((elem)=>elem.status === "active").filter((_element)=>{
        if(_element?.role ==="doctor" && _element?.is_doctor_verified){
          return _element
        }
        else if(_element?.role !== "doctor"){
          return _element
        }
        return;
      }).map((element) => ({
        ...element,
        value: element?._id,
        label: `${element?.first_name} ${element?.last_name}`,
      }));
      draft.staffSelectList = tempStaffSelectList;
      break;
    }
    case Actions.GET_STAFFS_SELECT_LIST_FOR_REQUESTS: {
      const tempStaffSelectList = payload?.staffs?.data?.map((element) => ({
        ...element,
        value: element?._id,
        label: `${element?.first_name} ${element?.last_name}`,
      }));
      draft.staffSelectListForRequests = tempStaffSelectList;
      break;
    }

    case Actions.SELECTED_STAFF_ID: {
      draft.selectedStaffId = payload?.selectedStaffId;
      break;
    }

    case Actions.SELECTED_STAFF_ID_FOR_UPDATE_ORDER_STATUS: {
      draft.selectedStaffIdForUpdateOrderStatus =
        payload?.selectedStaffIdForUpdateOrderStatus;
      break;
    }
    case Actions.GET_REQUEST_STAFF_LIST: {
      const tempStaffSelectList = payload?.map((element) => ({
        ...element,
        value: element?._id,
        label: `${element?.first_name} ${element?.last_name}`,
      }));
      draft.requestStaffList = tempStaffSelectList;
      break;
    }

    case Actions.GET_STAFF_BY_ID: {
      draft.staff = payload?.staff;
      break;
    }

    case Actions.CLEAR_TEMP_STAFF: {
      draft.requestStaffList = [];
      break;
    }

    case Actions.SELECTED_STAFF_RENEWAL_DETAILS: {
      draft.selectedStaffRenewalDetails = payload?.selectedStaffRenewalDetails;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default staff;
